import { Controller } from 'stimulus';
import Swiper from 'swiper';
import {
  Mousewheel,
  Navigation,
  Pagination,
  Scrollbar,
} from 'swiper/modules';

class Slider extends Controller {
  connect() {
    Swiper.use([Mousewheel, Navigation, Pagination, Scrollbar]);

    this.swiper = new Swiper(this.element, {
      slidesPerView: 'auto',
      spaceBetween: 32,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.horizontalScrollRowArrowNext',
        prevEl: '.horizontalScrollRowArrowPrev',
      },
      loop: this.data.get('loop') === 'true',
      autoHeight: this.data.get('auto-height') === 'true',
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
    });
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}

Slider.targets = [
  'leftArrow',
  'rightArrow',
  'scrollbar',
];

export default Slider;
